export default __webpack_public_path__ + "static/media/splash-screen-photo.3261d9c9.jpg";